export default {
  beforeDestroy() {
    // this.$slots.default &&
    //   this.$slots.default.every(el => {
    //     el.context.nativeView.disposeNativeView();
    //     el.context.nativeView._tearDownUI();
    //   });
  }
};
